import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { FormFormationModel } from '../../models/formations/formFormation.model';
import { FormationsPath } from '../../pages/formations/formations-path';
import { FormationsService } from '../../services/formations/formations.service';
import { UrlNumberParamResolverHelper } from '../url-number-param-resolver-helper';

@Injectable({
  providedIn: 'root',
})
export class FormationResolverService extends UrlNumberParamResolverHelper  {
  constructor(private formationsService: FormationsService) {
    super();
  }

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<FormFormationModel> | Promise<FormFormationModel> | FormFormationModel {
    const idFormation = this.findParam(FormationsPath.ID_FORMATION_PARAM_MAP, route);
    if (idFormation) {
      return this.formationsService.getFormationWithProgramme(idFormation);
    }
    return of(null);
  }
}
